angular.module('common.directives.meshViewer', [])

    .directive('meshViewer', function ($window) {
        return {
            restrict: 'E',
            templateUrl: 'common/directives/meshViewer/meshViewer.html',
            scope: {
                boundingBoxColor: '@',
                sceneBackgroundColor: '@',
                noFog: '@',
                fogFar: '@',
                forNear: '@',
                gridSize: '@'
            }, // TODO передовать меши через скоуп, в массиве, но обязательно чистить его.
            controller: 'MeshViewerController',
            link: function (scope, element, attrs) {
                angular.element($window).bind('resize', function () {

                    scope.doResize(); //trigger resize handler in case the overall browser window was resized,
                                      //so handler inside will set the renderer's canvas height/width to the actual height/width of its parent

                    // manuall $digest required as resize event
                    // is outside of angular
                    scope.$digest();
                });
            }
        };
    })

    .controller('MeshViewerController', function ($scope, $element, meshViewerDataService) {

        var bBoxColor = $scope.boundingBoxColor || 'ffff00';
        bBoxColor = bBoxColor.replace('#', '');

        var sceneBackColor = $scope.sceneBackgroundColor || 'e0e0e0';
        sceneBackColor = sceneBackColor.replace('#', '');

        var config = {
            drawBoundingBoxes: true,
            boundingBoxColor: Number('0x' + bBoxColor),
            drawGrid: true,
            drawAxes: true,
            alignAxeIndex: 0, // 0 - x, 1 - y, 2 - z
            alignOffset: 20,

            // TODO lights
            // TODO materials
        };


        var grid;
        var scene;
        var camera;
        var controls; // Orbit Controls to control camera by mouse
        var renderer;
        var destructing = false;
        var sceneObjects = [];
        var boundingBoxHelpers = [];

        /**
         * Renderer width
         */
        var width;

        /**
         * Renderer height
         */
        var height;

        /**
         * Container DOM element for Three.js renderer
         */
        var $containerElem;

        /**
         * Id returned by requestAnimationFrame function
         */
        var animationFrameId;

        init();

        function init() {
            $containerElem = $("#om-mesh-viewer-container");
            initThreeJs();

            $containerElem.resize(function () { // on resize event
                resizeCanvasToDisplaySize();
            });
            $scope.doResize = resizeCanvasToDisplaySize;

            meshViewerDataService.init();
            meshViewerDataService.onGeometriesAdd(function (newGeometries) {
                if (newGeometries && newGeometries.length > 0) {
                    addGeometries(newGeometries);
                }
            });
            meshViewerDataService.onGeometriesClear(function () {
                clearGeometries();
            });

            $scope.$on("$destroy", function () {
                destroy();
            });
        }

        /**
         * Controller destructor
         */
        function destroy() {
            // stop animation
            destructing = true;
            if (animationFrameId != null && cancelAnimationFrame) {
                cancelAnimationFrame(animationFrameId);
            }

            meshViewerDataService.destroy();

            clearGeometries();

            // renderer.domElement.addEventListener('dblclick', null, false); // remove listener to render
            if (controls && controls.dispose) {
                controls.dispose();
            }
            if (scene && scene.dispose) {
                scene.dispose();
            }
            if (renderer && renderer.dispose) {
                renderer.dispose();
            }

            scene = null;
            camera = null;
            controls = null;
            renderer = null;

            $containerElem.empty();
        }

        /**
         * Init three.js stuff
         */
        function initThreeJs() {
            if (renderer !== undefined && renderer != null) {
                return;
            }

            // Init renderer
            renderer = new THREE.WebGLRenderer({antialias: true, alpha: true});
            renderer.setPixelRatio(window.devicePixelRatio);
            width = $containerElem.width();
            height = $containerElem.height();
            renderer.setSize(width, height);
            $containerElem.append(renderer.domElement);

            // Init scene
            scene = new THREE.Scene();
            scene.background = new THREE.Color(Number('0x' + sceneBackColor));

            if (!(angular.isDefined($scope.noFog) && $scope.noFog === true)) {
                //Set default fog for the scene
                scene.fog = new THREE.Fog(Number('0x' + sceneBackColor), Number($scope.fogNear || 100), Number($scope.fogFar || 200));
            }

            // Helpers
            if (config.drawAxes) {
                scene.add(new THREE.AxesHelper(100));
            }

            // Lights
            addLightsToScene();

            // Init camera (camera near and far clipping planes will updated later after all geometries added)
            camera = new THREE.PerspectiveCamera(45, width / height, 1, 4000);

            // Init orbiting with mouse control
            initOrbitControls();

            camera.position.set(2, 2, 1);
            controls.update(); // update() must be called after any manual changes to the camera's transform

            animationFrameId = requestAnimationFrame(animate);
        }

        function addLightsToScene() {
            //Ambient light first to make the models looks more volumetric
            scene.add(new THREE.AmbientLight(0x3D3A2A));

            //And two opposite directional lights to cast some shadows
            var directionalLights = [
                {position: {x: 400, y: 400, z: 100}, color: 0xC1A87D, intensity: 0.9},
                {position: {x: -400, y: -400, z: -100}, color: 0xC1A87D, intensity: 0.9}
            ];

            directionalLights.forEach(function (ld) {
                var dirLight = new THREE.DirectionalLight(ld.color, ld.intensity);
                dirLight.position.set(ld.position.x, ld.position.y, ld.position.z);
                dirLight.castShadow = true;
                dirLight.shadow.camera.near = 1;
                dirLight.shadow.camera.far = 50;
                //dirLight.shadow.bias = -0.001;

                dirLight.shadow.camera.right = 1;
                dirLight.shadow.camera.left = -1;
                dirLight.shadow.camera.top = 1;
                dirLight.shadow.camera.bottom = -1;

                dirLight.shadow.mapSize.width = 1024;
                dirLight.shadow.mapSize.height = 1024;
                scene.add(dirLight);
            });
        }

        function initOrbitControls() {
            // https://threejs.org/docs/#examples/controls/OrbitControls
            controls = new THREE.OrbitControls(camera, renderer.domElement);

            // Damping (inertia), which can be used to give a sense of weight to the controls.
            controls.enableDamping = true;
            controls.dampingFactor = 0.6;

            controls.enableKeys = true; // keyboard controls
            controls.enableZoom = true;
            controls.enablePan = true;
            controls.enableRotate = true;
        }

        /**
         * Animate infinite loop
         * @param {number} [time] A DOMHighResTimeStamp similar to the one returned by performance.now(), indicating
         *   the point in time when requestAnimationFrame() starts to execute callback functions
         * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMHighResTimeStamp
         */
        function animate(time) {
            if (destructing === true) {
                return;
            }
            controls.update(); // required if controls.enableDamping or controls.autoRotate are set to true
            renderer.render(scene, camera);
            animationFrameId = requestAnimationFrame(animate);
        }

        /**
         * Function to resize canvas. Should be called if container size was changed
         */
        function resizeCanvasToDisplaySize() {

            if (!renderer || !renderer.domElement) {
                return;
            }

            var container = renderer.domElement.parentElement;
            if (!container) {
                return;
            }

            width = container.clientWidth;
            height = container.clientHeight;
            camera.aspect = width / height;
            camera.updateProjectionMatrix();
            renderer.setSize(width, height);
            // renderer.setSize(width, height, false);

            // TODO update any render target sizes here
        }

        /**
         * Add new mesh to scene
         * @param {Array<Object>} geometries list of arrays
         */
        function addGeometries(geometries) {
            for (var i = 0; i < geometries.length; i++) {
                var geometry = geometries[i];
                var box;

                if (geometry instanceof THREE.BufferGeometry) {
                    var materials = [];
                    var hasColors = geometry.hasColors;
                    var alpha = geometry.alpha;

                    //Delete all normals first so we can merge vertices at the same positions
                    geometry.deleteAttribute('normal');

                    //Merge vertices at the same positions (depending on tolerance) taking into account colors (by merging them)
                    geometry = mergeVertices(geometry);

                    //Compute normals
                    geometry.computeVertexNormals();

                    //And finally make it smoother
                    geometry = THREE.BufferGeometryUtils.toCreasedNormals(geometry, 45);
                    geometry.hasColors = hasColors;
                    geometry.alpha = alpha;

                    if (geometry.hasColors) {
                        materials.push(new THREE.MeshPhongMaterial({ opacity: geometry.alpha, vertexColors: true, side: THREE.DoubleSide }));
                    } else {
                        materials = [
                            new THREE.MeshPhongMaterial({ color: 0xaba069, shininess: 30, emissive: 0x806a5b, specular: 0x111111, side: THREE.FrontSide }),
                            new THREE.MeshPhongMaterial({ color: 0x7C6838, shininess: 30, emissive: 0x843A1F, specular: 0x111111, side: THREE.BackSide })
                        ];
                    }

                    //Create mesh and assign faces the proper material index for the front and back side of the faces
                    var mesh = new THREE.Mesh(geometry, materials[0]);

                    //If geometry has no colors and we have created two colors for front and back side faces, create a mesh to render inner faces
                    //We do it explicitly here cause we have a BufferGeometry without faces in it
                    if (!geometry.hasColors && materials.length > 1) {
                        mesh.material.side = THREE.FrontSide;
                        var meshInner = new THREE.Mesh(geometry, materials[1]);
                        meshInner.material.side = THREE.BackSide;
                        meshInner.material.vertexColors = THREE.NoColors;
                        mesh.add(meshInner);
                    }

                    mesh.castShadow = true;
                    mesh.receiveShadow = true;

                    //Add mesh to the scene
                    scene.add(mesh);
                    sceneObjects.push(mesh);

                    //Draw bounding box if configured so
                    if (config.drawBoundingBoxes) {
                        box = new THREE.BoxHelper(mesh, config.boundingBoxColor);
                        scene.add(box);
                        boundingBoxHelpers.push(box);
                    }
                } else if (geometry instanceof THREE.Group) {
                    scene.add(geometry);
                    sceneObjects.push(geometry);
                    if (config.drawBoundingBoxes) {
                        box = new THREE.BoxHelper(geometry, config.boundingBoxColor);
                        scene.add(box);
                        boundingBoxHelpers.push(box);
                    }
                } else if (geometry instanceof THREE.Scene) {
                    // TODO
                } else if (geometry instanceof THREE.Object3D) { // Default handler
                    // TODO
                }
            }

            // Align meshes in one row
            // and move camera position to see all the meshes
            alignMeshesAndCamera();
        }

        /**
         * Align all the meshes in single row.
         */
        function alignMeshesAndCamera() {
            var meshMargin = config.alignOffset;
            var nextMeshCenterShift = 0;
            var maxYSize = 0;
            var maxZSize = 0;


            for (var i = 0; i < sceneObjects.length; i++) {
                var sceneObject = sceneObjects[i];

                var boundingBoxHelper = boundingBoxHelpers[i];
                var boundingBox;

                boundingBox = new THREE.Box3().setFromObject(boundingBoxHelper);

                // Getting center of bounding box
                var center = new THREE.Vector3(); // this coordinates returns in mesh-oriented coordinates
                boundingBox.getCenter(center); // converting to world coordinates

                // getting size of bounding box
                var size = new THREE.Vector3();
                boundingBox.getSize(size);

                if (size.y > maxYSize) {
                    maxYSize = size.y;
                }
                if (size.z > maxZSize) {
                    maxZSize = size.z;
                }

                // We will place meshes one by one on the Ox axis.
                // The meshes themselves will be positioned so that the center of the Bounding Box lies on the Ox axis

                // calculate next position on oX axis
                var boundingBoxDestinationPosition = new THREE.Vector3(nextMeshCenterShift + size.x / 2, 0, 0);

                // Vector describing shift between bounding box center and next position on Ox axis
                var shift = new THREE.Vector3()
                    .subVectors(boundingBoxDestinationPosition, center);

                // Apply that shift to the scene 3dObject position
                sceneObject.position.add(shift);

                nextMeshCenterShift = nextMeshCenterShift + size.x + meshMargin;

                boundingBoxHelper.update();
            }

            // Fix camera position
            var maxDimension = nextMeshCenterShift > maxYSize ? nextMeshCenterShift : maxYSize;
            if (maxDimension < maxZSize) {
                maxDimension = maxZSize;
            }
            var dist = maxDimension / 1.5 / Math.tan(Math.PI * camera.fov / 360);

            camera.position.set((nextMeshCenterShift - meshMargin) / 2, maxYSize, dist);

            //Update the fog according to total bounding box size, so it will not hide the object but only the edges of the grid
            if (scene.fog) {
                scene.fog.near = maxDimension * 6;
                scene.fog.far = maxDimension * 10;
            }

            //Update grid size according to objects size, so it won't be too large yet we will not see its edges
            if (config.drawGrid) {
                grid = new THREE.GridHelper(maxDimension * 20, maxDimension / 2, 0x000000, 0x000000);
                grid.material.opacity = 0.1;
                grid.material.transparent = true;
                scene.add(grid);
            }

            //Update camera farther clipping plane according to objects size
            camera.far = maxDimension * 14;

            controls.target = new THREE.Vector3((nextMeshCenterShift - meshMargin) / 2, 0, 0);
            controls.update();
            controls.saveState();
        }

        /**
         * Clear all meshes from scene
         */
        function clearGeometries() {
            if (!scene) {
                return;
            }

            if (sceneObjects) {
                // scene.traverse is more right way, but it is really buggy
                for (var i = 0; i < sceneObjects.length; i++) {
                    var obj = sceneObjects[i];
                    if (scene && scene.remove) {
                        scene.remove(obj);
                    }
                }
                sceneObjects = [];
            }

            if (boundingBoxHelpers) {
                for (var j = 0; j < boundingBoxHelpers.length; j++) {
                    scene.remove(boundingBoxHelpers[j]);
                }
                boundingBoxHelpers = [];
            }
        }

        function mergeVertices(geometry, tolerance = 1e-4) {

            class VerticesColorsHolder {
                constructor(rgbArray) {
                    this.summColors = rgbArray;
                    this.verticesCount = 1;
                    this.averageColor = Array.from(rgbArray); //Just to hold pre-calculated average for faster get
                }

                addVertexColor(rgbArray) {
                    if(!this.summColors) return;
                    if(!rgbArray || rgbArray.length !== this.summColors.length) return;

                    this.verticesCount++;

                    for(let i = 0; i < this.summColors.length; i++) {
                        this.summColors[i] += rgbArray[i];
                        this.averageColor[i] = this.summColors[i] / this.verticesCount;
                    }
                }

                getAverageColor() {
                    return this.averageColor;
                }
            }

            tolerance = Math.max(tolerance, Number.EPSILON);

            // Generate an index buffer if the geometry doesn't have one, or optimize it
            // if it's already available.
            const hashToIndex = {};
            const indices = geometry.getIndex();
            const positions = geometry.getAttribute('position');
            const vertexCount = indices ? indices.count : positions.count;

            // next value for triangle indices
            let nextIndex = 0;

            // attributes and new attribute arrays
            const attributeNames = Object.keys(geometry.attributes);
            const tmpAttributes = {};
            const tmpMorphAttributes = {};
            const newIndices = [];
            const getters = ['getX', 'getY', 'getZ', 'getW'];
            const setters = ['setX', 'setY', 'setZ', 'setW'];

            // See if geometry has colors, so the resulting geometry will has colors as well (meaning we have to merge them)
            // by averaging colors of the merged vertices
            const hasColors = geometry.hasColors || attributeNames.includes('color');
            let oldColorsMap = [];

            // Initialize the arrays, allocating space conservatively. Extra
            // space will be trimmed in the last step.
            for (let i = 0, l = attributeNames.length; i < l; i++) {

                const name = attributeNames[i];
                const attr = geometry.attributes[name];
                tmpAttributes[name] = new THREE.BufferAttribute(new attr.array.constructor(attr.count * attr.itemSize), attr.itemSize, attr.normalized);
                const morphAttr = geometry.morphAttributes[name];
                if (morphAttr) {
                    tmpMorphAttributes[name] = new THREE.BufferAttribute(new morphAttr.array.constructor(morphAttr.count * morphAttr.itemSize), morphAttr.itemSize, morphAttr.normalized);
                }

            }

            // convert the error tolerance to an amount of decimal places to truncate to
            const decimalShift = Math.log10(1 / tolerance);
            const shiftMultiplier = Math.pow(10, decimalShift);
            for (let i = 0; i < vertexCount; i++) {

                const index = indices ? indices.getX(i) : i;

                // Generate a hash for the vertex attributes at the current index 'i'
                let hash = '';

                for (let j = 0, l = attributeNames.length; j < l; j++) {

                    const name = attributeNames[j];
                    const attribute = geometry.getAttribute(name);
                    const itemSize = attribute.itemSize;

                    if (name === 'color') continue; //do not use color information for vertex descriptor as we want to
                                                    //merge vertices with different colors and just average their color
                                                    //into a merged one

                    for (let k = 0; k < itemSize; k++) {
                        // double tilde truncates the decimal value
                        hash += `${~~(attribute[getters[k]](index) * shiftMultiplier)},`;
                    }
                }

                // Add another reference to the vertex if it's already
                // used by another index
                if (hash in hashToIndex) {

                    newIndices.push(hashToIndex[hash]);

                    if(attributeNames.includes('color')) {
                        //Then on any 'merged' vertex we need to store its color into old colors map
                        const name = 'color';
                        const attribute = geometry.getAttribute(name);
                        const itemSize = attribute.itemSize;
                        const oldColor = [];
                        for (let k = 0; k < itemSize; k++) {
                            const getterFunc = getters[k];
                            const setterFunc = setters[k];

                            oldColor[k] = attribute[getterFunc](index);
                        }
                        oldColorsMap[hashToIndex[hash]].addVertexColor(oldColor);
                    }

                } else {
                    // copy data to the new index in the temporary attributes
                    for (let j = 0, l = attributeNames.length; j < l; j++) {
                        const name = attributeNames[j];
                        const attribute = geometry.getAttribute(name);
                        const morphAttr = geometry.morphAttributes[name];
                        const itemSize = attribute.itemSize;
                        const newarray = tmpAttributes[name];
                        const newMorphArrays = tmpMorphAttributes[name];
                        const oldColor = [];

                        for (let k = 0; k < itemSize; k++) {
                            const getterFunc = getters[k];
                            const setterFunc = setters[k];
                            newarray[setterFunc](nextIndex, attribute[getterFunc](index));

                            if(name === 'color') {
                                //Get the color value for vertex found and store into the map for later calculation
                                //of the average color of all the merged vertex for particular position  (depending on tolerance)
                                oldColor[k] = attribute[getterFunc](index);
                            }
                            if (morphAttr) {
                                for (let m = 0, ml = morphAttr.length; m < ml; m++) {
                                    newMorphArrays[m][setterFunc](nextIndex, morphAttr[m][getterFunc](index));
                                }
                            }
                        }
                        if(name === 'color') {
                            //Store the first color value for vertex found
                            if(!oldColorsMap[nextIndex]) {
                                oldColorsMap[nextIndex] = new VerticesColorsHolder(oldColor);
                            }
                            else {
                                oldColorsMap[nextIndex].addVertexColor(oldColor);
                            }
                        }
                    }

                    hashToIndex[hash] = nextIndex;
                    newIndices.push(nextIndex);
                    nextIndex++;
                }
            }

            // generate resulting THREE.BufferGeometry
            const result = geometry.clone();
            result.hasColors = hasColors;

            for (const name in geometry.attributes) {
                const tmpAttribute = tmpAttributes[name];

                if(name === 'color') {
                    //update colors information in the buffer attribute object
                    for(let i = 0; i < oldColorsMap.length; i++) {
                        tmpAttribute.set(oldColorsMap[i].averageColor, i * tmpAttribute.itemSize);
                    }
                    tmpAttribute.needsUpdate = true;
                }
                result.setAttribute(name, new THREE.BufferAttribute(tmpAttribute.array.slice(0, nextIndex * tmpAttribute.itemSize), tmpAttribute.itemSize, tmpAttribute.normalized));

                if (!(name in tmpMorphAttributes)) continue;
                for (let j = 0; j < tmpMorphAttributes[name].length; j++) {
                    const tmpMorphAttribute = tmpMorphAttributes[name][j];
                    result.morphAttributes[name][j] = new THREE.BufferAttribute(tmpMorphAttribute.array.slice(0, nextIndex * tmpMorphAttribute.itemSize), tmpMorphAttribute.itemSize, tmpMorphAttribute.normalized);
                }
            }

            // indices
            result.setIndex(newIndices);

            //Clean up a bit
            oldColorsMap = null;

            return result;

        }
    })

    .service('meshViewerDataService', function () {
        var _this = this;

        var _onGeometriesAdd;
        var _onGeometriesClear;
        _this.geometries = [];

        _this.init = function () {
            _this.geometries = [];
            _onGeometriesAdd = void 0;
        };

        _this.destroy = function () {
            _this.geometries = [];
            _onGeometriesAdd = void 0;
        };

        _this.addGeometry = function (geometry) {
            _this.geometries.push(geometry);
            if (_onGeometriesAdd) {
                _onGeometriesAdd([geometry]);
            }
        };

        _this.addGeometries = function (geometries) {
            _this.geometries.concat(geometries);
            if (_onGeometriesAdd) {
                _onGeometriesAdd(geometries);
            }
        };

        _this.clearGeometries = function () {
            _this.geometries = [];
            if (_onGeometriesClear) {
                _onGeometriesClear();
            }
        };

        _this.onGeometriesClear = function (func) {
            _onGeometriesClear = func;
        };

        _this.onGeometriesAdd = function (func) {
            _onGeometriesAdd = func;
            if (_this.geometries && _this.geometries.length > 0) {
                _onGeometriesAdd(_this.geometries);
            }
        };

        return this;
    })
;
